import { apim } from "@/constants/api"
import { CART_OFFER_ENDPOINT } from "@/constants/routes"
import { CART_DISCOUNT_THRESHOLD_COUNT } from "@/services/constants"

/**
 * Fetches cart threshold data from the cart offer API
 *
 * This function retrieves information about available discounts and
 * promotional offers based on spending thresholds for a specific cart.
 * The number of offers returned is controlled by the CART_DISCOUNT_THRESHOLD_COUNT
 * .
 *
 * @param {string} cartId - The unique identifier of the cart
 * @return {Promise<Array<Object>|null>} An array of threshold objects or null if no data available
 * @property {number} thresholdPrice - The amount needed to qualify for the offer
 * @property {number} diffPrice - The price above which the offer will be shown
 * @property {string} code - The discount code identifier
 * @property {string} description - Human-readable description of the offer
 */
export const getCartThresholdData = async cartId => {
  if (!cartId) return null

  try {
    const response = await apim.get(
      `${CART_OFFER_ENDPOINT}&discountCount=${CART_DISCOUNT_THRESHOLD_COUNT}&cartId=${cartId}`
    )

    if (response.data && response.data.length > 0) {
      return response.data.map(offer => ({
        thresholdPrice: offer.thresholdPrice,
        diffPrice: offer.diffPrice,
        code: offer.code,
        description: offer.description,
      }))
    }
    return null
  } catch (error) {
    console.error("Error fetching cart threshold data:", error)
    return null
  }
}
